module.exports = {"title":"Register Inquiry","typeLabel":"Type","typeSelectPlaceholder":"Select a type.","titleLabel":"Title","titlePlaceholder":"Enter a title.","contentPlaceholder":"Enter content.","typeService":"Service","typeEvent":"Event","typeUpdate":"Update","templateService":"Device: PC / Mobile \n","templateEvent":"Event details: \n","templateUpdate":"Update version: \n","registeredAlert":"Your inquiry has been registered.","registerFailedAlert":"Failed to register the post.<br>Please try again."}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en/cs103.json
// module id = iH+X
// module chunks = 2